import { getFetch, putFetch } from 'utils/fetch'
import { getConfigApi } from '../config'

const prefix = 'hook'

function getUrl(path = '') {
  return getConfigApi()[ prefix ] + '/' + path
}

export async function getOrgHook() {
  const result = await getFetch(getUrl(`organization`))
  if (result.lenght !== 0) {
    return result[ 0 ].url
  }
}

export async function updateOrgHook(data = {}) {
  return await putFetch(getUrl(`organization`), data)
}

export default {
  updateOrgHook,
}



// WEBPACK FOOTER //
// ./src/api/hook.js